import { render, staticRenderFns } from "./V3SideBarItemExpandableNew.vue?vue&type=template&id=4ed34a20&scoped=true"
import script from "./V3SideBarItemExpandableNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./V3SideBarItemExpandableNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./V3SideBarItemExpandableNew.vue?vue&type=style&index=0&id=4ed34a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed34a20",
  null
  
)

export default component.exports